export default "__VITE_ASSET__92nzvsP8__"